module.exports = __webpack_public_path__ + "img/38.718150fe.jpg";